import { createSlice } from "@reduxjs/toolkit";

export const sampleSlice = createSlice({
  name: "sample",
  initialState: {
    sample: "sample",
  },
  reducers: {
    setSample: (state, action) => {
      state.sample = action.payload;
    },
  },
});

export const { setSample } = sampleSlice.actions;

export default sampleSlice.reducer;
